import React, { useState, useEffect } from 'react'
import axios from 'axios';
import FormTip from '../../commons/form_tip';
import {getCsrfToken} from '../../commons/authenticityToken';

const Index = (props) => {
    axios.defaults.headers.common['X-CSRF-Token'] = getCsrfToken();
    
    const partGroupInit = {id: 0, name: null, display_web_name: null, description: null}

    // テンプレート内容
    const [ partGroup, setPartGroup ] = useState(partGroupInit);
    // カテゴリ検索結果
    const [ resultParts, setResultParts ] = useState([]);
    // 検索
    const [ searchName, setSearchName ] = useState("");
    const [ searchPartOwnerKbn, setSearchPartOwnerKbn ]  = useState(["0", "1"]);
    // 選択中のカテゴリ
    const [ checkedPartIds, setCheckedPartIds ] = useState([]);
    // 選択中のカテゴリリスト
    const [ parts, setParts ] = useState([]);
    // レンダリング用
    const [update, setUpdate] = useState<Boolean>(false);
    // 選択中のカテゴリ
    const [ checkedPartId, setCheckedPartId ] = useState(null);
    // エラーメッセージ
    const [ errorMessage, setErrorMessage] = useState("");

    // 初回ロード
    useEffect(() =>{
        if (props.is_edit){
            axios.get(
                '/api/internal/part_groups/edit', {params: {id: props.part_group_id}}
                )
                .then(function (response) {
                    setPartGroup(response.data.m_part_group);
                    setParts(response.data.m_parts);
                })
                .catch(error => {
                    setErrorMessage(error.response.data.message);
                });
        }else{
            axios.get(
                '/api/internal/part_groups/new', {})
                .then(function (response) {
                    setPartGroup(response.data.m_part_group);
                    setParts(response.data.m_parts);
                })
                .catch(error => {
                    setErrorMessage(error.response.data.message);
                }
            )
        }
    },[])
    
    // カテゴリ検索
    function searchParts(){
        initSearchForm();
        axios.get(
        '/api/internal/parts/search_parts', {
            params: { name:  searchName, share_range_kbn: searchPartOwnerKbn }
        })
        .then(function (response) {
            const m_parts = response.data.m_parts
            setResultParts(m_parts);
        })
        .catch(error => {
            setResultParts([]);
            alert(error.response.data.message);
        }); 
    }

    // カテゴリ追加
    function addPartGroup(){
        const partGroupDup = parts;
        checkedPartIds.map((checkedPartId) => {
            const addPartGroup = resultParts.find(part => part.id === checkedPartId);
            const part_group = parts.find(part_group => part_group.id === checkedPartId);
            // 選択中のカテゴリリストに存在しない場合のみ追加
            if(!part_group){
                partGroupDup.push(addPartGroup);
            }
        })
        setParts(partGroupDup);
        initSearchForm();
        setUpdate(update?false:true);
    }

    // カテゴリ削除
    function removePartGroup(){
        setParts(parts.filter(part => part.id !== checkedPartId));
        setCheckedPartId(null);
    }

    // カテゴリ移動
    function moveRow(type){
        if(checkedPartId === "") return;

        const partsDup = parts.slice();
        const targetIndex = partsDup.findIndex(partGroup => partGroup.id === checkedPartId)

        switch(type){
            case "up":
                if(targetIndex === 0) return;
                partsDup.splice( targetIndex - 1, 2, partsDup[targetIndex], partsDup[targetIndex - 1]);
                break;
            case "down":
                if(targetIndex === (parts.length - 1)) return;
                partsDup.splice( targetIndex, 2, partsDup[targetIndex + 1], partsDup[targetIndex]);
                break;
        }
        setParts(partsDup);
    }

    // 検索フォーム初期化
    function initSearchForm(){
        setResultParts([]);
        setCheckedPartIds([]);
    }

    // チェックボックス選択
    function changeCheckedPartIds(value){
        const checkedPartGroupIdsDup = checkedPartIds
        const isChecked = checkedPartIds.includes(value);
        if(isChecked){
            setCheckedPartIds(checkedPartGroupIdsDup.splice(value));
        }else{
            checkedPartGroupIdsDup.push(value);
            setCheckedPartIds(checkedPartGroupIdsDup);
        }
        setUpdate(update?false:true);
    }

    function changeCheckedPartId(value){
        setCheckedPartId(value);
        setUpdate(update?false:true);
    }

    function submitPartGroup(){
        setErrorMessage("");
        if (props.is_edit){
            axios.post(
                '/api/internal/part_groups/update', {
                    part_group: partGroup, parts: parts
                })
                .then(function () {
                    location.href = ("/part_groups/index");
                })
                .catch(error => {
                    setErrorMessage(error.response.data.message)
                });
        }else{
            axios.post(
                '/api/internal/part_groups/create', {
                    part_group: partGroup, parts: parts
                })
                .then(function () {
                    location.href = ("/part_groups/index");
                })
                .catch(error => {
                    setErrorMessage(error.response.data.message)
                });
        }

    }

    // チェックボックス更新
    function changePartOwner(target) {
        if (target.checked){
            setSearchPartOwnerKbn([...searchPartOwnerKbn, target.value]);
        }else{
            setSearchPartOwnerKbn(searchPartOwnerKbn.filter(value => value !== target.value));
        }
    }

    return(
        <>
            { errorMessage && 
                <div className="alert alert-danger alert-dismissible" role="alert">
                    <button 
                        type="button"
                        className="close"
                        data-dismiss="alert"
                        aria-label="閉じる">
                            <span aria-hidden="true">×</span>
                    </button>
                        {
                            errorMessage
                        }
                </div>
            }
            <div className="row">
                <div className="col-md-2 col-lg-3"/>
                <div className="col-xs-12 col-sm-12 col-md-8 col-lg-6">
                    <div className="form-group">
                        <FormTip description="カテゴリに名前をつけてください">
                            <label htmlFor="m_part_group_name">カテゴリ名</label><span className="label label-danger ml5">必須</span>
                        </FormTip>
                        <input 
                            className="form-control" 
                            placeholder="例：男性用_カテゴリ２" 
                            type="text" 
                            id="m_part_group_name"
                            defaultValue={partGroup.name}
                            onChange={(e) => setPartGroup({...partGroup, name: e.target.value})}
                        />
                    </div>

                    <div className="form-group">
                        <FormTip description="患者者入力画面に表示される際、カテゴリ名と別名称にしたい場合設定してください">
                            <label htmlFor="m_part_group_display_name">カテゴリ名（患者画面）</label>
                        </FormTip>
                        <input 
                            className="form-control" 
                            placeholder="例：併用薬・嗜好品・生活習慣" 
                            type="text" 
                            id="m_part_group_display_name"
                            defaultValue={partGroup.display_web_name}
                            onChange={(e) => setPartGroup({...partGroup, display_web_name: e.target.value})}
                        />
                    </div>

                    <div className="form-group">
                        <FormTip description="管理画面に表示される説明文">
                            <label htmlFor="m_part_group_description">カテゴリ詳細</label>
                        </FormTip>
                        <textarea 
                            rows={3}
                            className="form-control" 
                            placeholder="カテゴリ詳細を入力してください"
                            id="m_part_group_description"
                            defaultValue={partGroup.description}
                            onChange={(e) => setPartGroup({...partGroup, description: e.target.value})}
                        />
                    </div>

                    {/* 質問設定 */}
                    <div className="form-group">
                        <FormTip description="カテゴリに紐づく質問を設定してください">
                            <label htmlFor="m_part">質問設定</label><span className="label label-danger ml5">必須</span>
                        </FormTip>

                        <div className="text-left col-md-6 col-sm-6 col-xs-6 part-add">
                            { ( checkedPartId !== null) &&
                                <>
                                    <a className="btn btn-primary mr10" onClick={()=> moveRow('up')}>▲</a>
                                    <a className="btn btn-primary mr10" onClick={()=> moveRow('down')}>▼</a>
                                </>
                            }

                        </div>
                        <div className="text-right col-md-6 col-sm-6 col-xs-6 part-add">
                            <a className="btn btn-primary mr10" data-toggle="modal" data-target="#myModal">追加</a>
                            {( checkedPartId !== null) && (<a className="btn btn-danger mr10" onClick={()=> removePartGroup()}>削除</a>)}
                        </div>
                        
                        <table id="m_part_table" className="table table-bordered">
                            <thead>
                                <tr className="success">
                                    <th className="col-md-6 col-sm-6 col-xs-6 text-center">質問名</th>
                                    <th className="col-md-6 col-sm-6 col-xs-6 text-center">説明文</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    parts.map((part) => {
                                        const isChecked = part.id === checkedPartId;
                                        return(
                                        <tr className={isChecked && "select-part-group"} onClick={() => changeCheckedPartId(part.id)}>
                                            <td>{part.name}</td>
                                            <td>{part.description}</td>
                                        </tr>
                                        )
                                    })
                                }

                            </tbody>
                        </table>
                    </div>

                    {/* ボタン類 */}
                    <div>
                        <div className="actions mt40">
                            <a className="btn btn-primary pull-left m5" href="/part_groups/index">戻る</a>
                            <a className="btn btn-primary pull-right m5" onClick={() => submitPartGroup()}>
                                {(props.is_edit) ? ("更新する") : ("作成する") }
                            </a>
                        </div>
                    </div>
                </div>   
            </div>

            {/* モーダル */}
            <div id="myModal" className="modal fade" data-backdrop="static" role="dialog">
                <div className="modal-dialog videocall-modal">
                    <div className="modal-content">
                        <div className="modal-header text-center bg-success">
                            <h4 className="modal-title text-center">質問内容を選択してください</h4>
                        </div>
                        <div className="modal-body">
                            <div className="row">
                                <div className="form-group col-md-12 col-xs-12">
                                    <label htmlFor="m_part_name">質問名</label>
                                    <input className="form-control" placeholder="質問名" type="text" id="m_part_name" onChange={(e) => setSearchName(e.target.value)} />
                                </div>
                            </div>
                            <div className="row">
                                <div className="form-group col-md-12 col-xs-12">
                                    <div>
                                        <label>質問所有者</label>
                                    </div>
                                    <div className="col-md-4 col-xs-4">
                                        <input 
                                            type="checkbox" 
                                            name="search_template_owner_kbn"
                                            id="search_template_owner_kbn_0"
                                            value={0}
                                            defaultChecked={searchPartOwnerKbn.includes("0")}
                                            onChange={(e) => changePartOwner(e.target)}
                                        />
                                        <label htmlFor="search_template_owner_kbn_0">自社質問</label>
                                    </div>

                                    <div className="col-md-4 col-xs-4">
                                        <input 
                                            type="checkbox" 
                                            name="search_template_owner_kbn"
                                            id="search_template_owner_kbn_1"
                                            value={1}
                                            defaultChecked={searchPartOwnerKbn.includes("1")}
                                            onChange={(e) => changePartOwner(e.target)}
                                        />
                                        <label htmlFor="search_template_owner_kbn_1">共通質問</label>
                                    </div>
                                </div>
                            </div>

                            <div className="form-group">
                                <a className="btn btn-primary col-md-12 col-sm-12 col-xs-12" onClick={() => searchParts()}>検索</a>
                            </div>

                            <hr className="col-md-12 col-sm-12 col-xs-12"/>
                            
                            <div className="part-table-wrapper">
                                <table className="table table-bordered">
                                    <thead>
                                        <tr className="success">
                                            <th className="col-md-2 col-sm-2 col-xs-2 text-center">自社/共通</th>
                                            <th className="col-md-5 col-sm-5 col-xs-5 text-center">質問名</th>
                                            <th className="col-md-5 col-sm-5 col-xs-5 text-center">説明文</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            resultParts.map((part) => {
                                                const isChecked = checkedPartIds.includes(part.id);
                                                return (
                                                    <tr className={isChecked ? ("select-part") : ("")} onClick={() => changeCheckedPartIds(part.id)}>
                                                        <td>{part.share_range_kbn === 1 ? "共通" : "自社"}</td>
                                                        <td>{part.name}</td>
                                                        <td>{part.description}</td>
                                                    </tr>
                                                )
                                            })
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div className="modal-footer bg-success">
                            <div className="col-md-3 col-sm-3 col-xs-3">
                                <a className="btn btn-primary col-md-12 col-sm-12 col-xs-12" data-dismiss="modal">閉じる</a>
                            </div>
                            <div className="col-md-6 col-sm-6 col-xs-6"/>
                            
                            <div className="col-md-3 col-sm-3 col-xs-3">
                                {
                                    (checkedPartIds.length >= 1) ? (
                                        <button
                                            type="button" 
                                            className="btn btn-primary col-md-12 col-sm-12 col-xs-12 active" 
                                            data-dismiss="modal" 
                                            onClick={() => addPartGroup()}>追加</button>
                                    ) : (

                                        <button
                                            type="button"
                                            className="btn btn-primary col-md-12 col-sm-12 col-xs-12 disabled"
                                            onClick={() => addPartGroup()}>追加</button>
                                    )
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default Index;